<template>
	<div class="outer-box">
		<h4>Flush Dmarc Cache for an Email Domain</h4>

		<div class="inner-box" style="text-align: left; width: 500px">
			<input
				class="hl_input--wrap"
				type="text"
				placeholder="Email Address"
				v-model="emailAddress"
			/>
			<button class="btn btn-primary mt-4" @click="flushDmarcForEmailDomain">
				<moon-loader
					v-if="processing"
					:loading="true"
					size="21px"
					color="#fafafa"
				/>
				<span v-else> Flush Cache </span>
			</button>
			<div class="code-wrapper" style="position: relative" v-if="response">
				<pre
					id="text-copy"
					style="background-color: #f2f7fa; padding: 16px; margin-top: 16px"
					>{{ response }}</pre
				>
				<div class="copy-icon">
					<i v-if="!copied" class="far fa-copy" @click="copyText()"></i>
					<p v-else class="text-success">Copied</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { EmailISVService } from '@/services';

export default {
	data() {
		return {
			emailAddress: "",
			processing: false,
			response: null,
			copied: false,
		};
	},
	methods: {
		flushDmarcForEmailDomain() {
			this.processing = true;
			EmailISVService.flushDmarc(this.emailAddress)
				.then((response) => {
					this.response = response.data;
				})
				.catch((error) => {
					this.response = error.response.data;
				})
				.finally(() => {
					this.processing = false;
				});
		},
		copyText() {
			const text = document.getElementById("text-copy").innerHTML;
			return navigator.clipboard
				.writeText(text)
				.then(() => {
					this.copied = true;
					setTimeout(() => {
						this.copied = false;
					}, 2000);
				})
				.catch((err) => {
					console.error(`Error copying text to clipboard: ${err}`);
				});
		},
	},
};
</script>

<style>
.copy-icon {
	cursor: pointer;
	position: absolute;
	top: 0;
	right: 0;
	margin: 10px;
}
</style>
